const DATE_SEPARATOR = 2;

export { DATE_SEPARATOR };
